/**
 * Canonical store listings for the Destination Hunts participant mobile app.
 *
 * These are the same permanent URLs the marketing landing page links to —
 * define them once here and import wherever a download link is rendered.
 *
 * Note: the Google Play production listing may 404 while Google's review is
 * pending; it is still the correct permanent URL (do not swap in the
 * internal-testing opt-in link).
 */
export const APP_STORE_URL = 'https://apps.apple.com/app/id6759203581';

export const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.destinationhunts.app';
